import { FC } from 'react';
import { TablePagination } from '@mui/material';
import { colors, fontWeights } from '../../theme/tokens';

// Footer of the XD listings ("Common structure" in DESIGN.md): "Lignes par
// page [25 ▾]" and "x - x sur xxx" with arrows. Server-side pagination: the
// page and the total come from the API; here it is only painted and reported.

export const PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 25;

type Props = {
  count: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

const ListPagination: FC<Props> = ({
  count,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => (
  <TablePagination
    component="div"
    count={count}
    page={page}
    rowsPerPage={pageSize}
    rowsPerPageOptions={PAGE_SIZE_OPTIONS}
    onPageChange={(_, nextPage) => onPageChange(nextPage)}
    onRowsPerPageChange={(e) => onPageSizeChange(Number(e.target.value))}
    labelRowsPerPage="Lignes par page"
    labelDisplayedRows={({ from, to, count: total }) =>
      `${from} - ${to} sur ${total}`
    }
    getItemAriaLabel={(type) =>
      type === 'next' ? 'Page suivante' : 'Page précédente'
    }
    sx={{
      mt: 1,
      color: colors.textBase,
      '& .MuiTablePagination-toolbar': {
        flexWrap: 'wrap',
        pl: 0,
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows':
        {
          fontSize: '0.875rem',
          m: 0,
        },
      '& .MuiTablePagination-select': {
        fontWeight: fontWeights.medium,
      },
    }}
  />
);

export default ListPagination;
